import index from '../../images/bizmsm/index.png';
import profile from '../../images/bizmsm/profile.png';
import wallet from '../../images/bizmsm/wallet.png';
import product from '../../images/bizmsm/product.png';
import order from '../../images/bizmsm/order.png';
import transactions from '../../images/bizmsm/transactions.png';
import merchant from '../../images/bizmsm/merchant.png';
import search from '../../images/bizmsm/search.png';
import addMerchandise from '../../images/bizmsm/addMerchandise.png';

export const BizImgs = [index,profile,wallet,product,order,transactions,merchant,search,addMerchandise];